import accountReducer from './reducer';

export const reducer = accountReducer;
